export const loadingConstants = {
	'LOADING': 'LOADING',
	'COMPLETED': 'COMPLETED',
	'NO_RESPONSE': 'NO_RESPONSE',
	'INVALID_RESPONSE': 'INVALID_RESPONSE'
};